var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon15SecForwards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2745 34C11.3909 34 5 27.732 5 20C5 12.268 11.3909 6 19.2745 6C24.1313 6 28.4215 8.37891 31 12.0135",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.159 12.6551L32.0782 13.9182L33.3398 7",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2539 31.8584H23.6895V21.0215L21 22.2256V20.749L25.0078 19H25.2539V31.8584Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5094 25.4424L29.0631 19.0615H34.6266V20.5645H30.3727L30.0739 24.0537C30.6012 23.6846 31.1696 23.5 31.7789 23.5C32.775 23.5 33.5573 23.8867 34.1256 24.6602C34.694 25.4336 34.9782 26.4736 34.9782 27.7803C34.9782 29.1045 34.6676 30.1445 34.0465 30.9004C33.4313 31.6562 32.5846 32.0342 31.5065 32.0342C30.5455 32.0342 29.7633 31.7207 29.1598 31.0938C28.5563 30.4668 28.2106 29.5996 28.1227 28.4922H29.5817C29.6696 29.2246 29.8776 29.7783 30.2057 30.1533C30.5397 30.5225 30.9733 30.707 31.5065 30.707C32.11 30.707 32.5817 30.4463 32.9215 29.9248C33.2614 29.3975 33.4313 28.6885 33.4313 27.7979C33.4313 26.96 33.2467 26.2773 32.8776 25.75C32.5143 25.2227 32.0221 24.959 31.401 24.959C30.8854 24.959 30.4723 25.0938 30.1618 25.3633L29.7487 25.7764L28.5094 25.4424Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15SecForwards);
export default __webpack_public_path__ + "static/media/icon-15sec-forwards.72995c5e93812e5d196e9722324acd0f.svg";
export { ForwardRef as ReactComponent };